import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import { LimitRow } from '@widgets';
import { BaseInput, ErrorMessage } from '@shared/widgets';

const NameEnum = {
  Retail: 'retail',
  Cash: 'cash',
  Otc: 'otc',
} as const;
type NameEnum = (typeof NameEnum)[keyof typeof NameEnum];
interface CardNewLimitRowProps {
  className?: string;
  limitRowLabel: string;
  currentAmount: number;
  currentNumber: number;
  limitAmount: number;
  limitNumber: number;
  symbol: string;
  name: NameEnum;
}

export const CardNewLimitRow = (props: CardNewLimitRowProps) => {
  const { control } = useFormContext();
  const { t } = useTranslation('card');

  return (
    <div className={cn('flex w-full max-w-[248px] flex-col gap-5', props.className)}>
      <LimitRow
        label={props.limitRowLabel}
        currentAmount={props.currentAmount}
        limitAmount={props.limitAmount}
        limitNumber={props.limitNumber}
        currentNumber={props.currentNumber}
        symbol={props.symbol}
      />
      <div className='flex flex-col gap-3'>
        <Controller
          name={`${props.name}Amount`}
          control={control}
          rules={{ pattern: { value: /^\d*\.?\d{0,2}$/, message: t('errors.form.incorrectValue', { ns: 'common' }) } }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput {...field} type='number' placeholder={t('sidebar.modals.requestNewLimits.placeholders.newAmount')} onlyPositive />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Controller
          name={`${props.name}Number`}
          control={control}
          render={({ field }) => (
            <BaseInput {...field} type='number' placeholder={t('sidebar.modals.requestNewLimits.placeholders.newTxnNumber')} onlyPositive />
          )}
        />
      </div>
    </div>
  );
};
